<template>
    <div class="wrapper">
        <NavBar />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="container-fluid py-2" style="background-color: white !important;">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-12 text-center wow fadeInDown">
                            <img :src="folder" alt="User Profil" class="img-size-50 mr-3 img-circle shake-element"
                                style="height: 80px !important;width: 80px !important;"><br><br>
                            <h5>Halo {{ sapaan }}, <span class="text-success">{{ namauser }}</span>, {{
                                jabatanuser }}
                            </h5>
                            <div class="row">
                                <div class="col-sm-2 text-center"></div>
                                <div class="col-sm-8 text-center">
                                    <div class="card" style="background-color: rgba(255, 255, 255, 0.1)">
                                        <div class="row py-2 px-5">

                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                {{ hasil }} {{ hariAngka }}
                                            </div>
                                            <div class="col-sm-12 text-center bgbiru"
                                                style="border-top-left-radius: 10px;border-top-right-radius: 10px;">
                                                <div class="col-sm-12 text-center">&nbsp;</div>
                                                <small class="text-white"> Status Absensi Hari Ini:</small>
                                            </div>
                                            <div class="col-sm-4 text-center bgbiru py-2">
                                                <span class="info-box-icon">
                                                    <i class="far fa-arrow-alt-circle-down text-white"
                                                        style="font-size: 50px;"></i>
                                                </span><br>
                                                <span class="info-box-text text-white">Masuk</span>
                                                <h5 class="info-box-number text-warning">
                                                    <span style="font-size: 11px;">{{ G_formatDateNonWIB(tanggal_masuk)
                                                        }}</span><br>
                                                    {{ jam_masuk }}
                                                </h5>
                                            </div>
                                            <div class="col-sm-4 text-center bgbiru py-2">
                                                <span class="info-box-icon">
                                                    <i class="far fa-arrow-alt-circle-up text-white"
                                                        style="font-size: 50px;"></i>
                                                </span><br>
                                                <span class="info-box-text text-white">Pulang</span>
                                                <h5 class="info-box-number text-warning">
                                                    <span style="font-size: 11px;">{{ G_formatDateNonWIB(tanggal_pulang)
                                                        }}</span><br>
                                                    {{ jam_pulang }}
                                                </h5>
                                            </div>
                                            <div class="col-sm-4 text-center bgbiru py-2">
                                                <span class="info-box-icon">
                                                    <i class="fas fa-briefcase text-white" style="font-size: 50px;"></i>
                                                </span><br>
                                                <span class="info-box-text text-white">Status</span>
                                                <h5 class="info-box-number" :class="class">{{ ket }}</h5>
                                            </div>
                                            <div class="col-sm-12 text-center bgbiru"
                                                style="border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
                                                <small class="info-box-text text-white">
                                                    <i class="far fa-clock"></i> Total Jam Kerja: {{ durasi }}
                                                </small>
                                                <div class="col-sm-12 text-center">&nbsp;</div>
                                            </div>
                                            <div class="col-sm-12 text-center">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 text-center"></div>
                            </div>
                        </div><!-- /.col -->
                        <div class="col-sm-12 text-center wow fadeInUp"
                            v-if="(latitude != '' && latitude != null && latitude != undefined && latitude != '0')">
                            <img src="../../../assets/img/absenmasuk.png" alt="Absen"
                                v-if="proses != 'sudahselesai' && statusjam == 'sudah'"
                                class="img-size-50 mr-3 img-circle gambar"
                                style="height: 150px !important;width: 150px !important;" @click.once="absenmasuk()">
                            <img src="../../../assets/img/absenpulang.png" alt="Absen" v-else
                                class="img-size-50 mr-3 img-circle"
                                style="height: 150px !important;width: 150px !important;">
                            <br>
                            <span class="birutua" v-if="proses != 'sudahselesai' && statusjam == 'sudah'"
                                style="font-weight: bold;"> TAP UNTUK
                                ABSEN {{ Upper(tipe) }}</span>
                            <span class="abu" v-else>
                                <span v-if="statusjam == 'belum'" style="font-weight: bold;">JAM KERJA BELUM
                                    MEMENUHI</span>
                                <span v-else style="font-weight: bold;">PROSES ABSENSI SUDAH SELESAI</span>
                            </span>
                        </div>
                        <div class="col-sm-12 text-center wow fadeInDown" v-else>
                            <div id="spinner"
                                v-if="latitude == '' || latitude == null || latitude == undefined || latitude == '0'"
                                class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
                                style="opacity: 0.6;position:absolute !important;">
                                <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;"
                                    role="status">
                                    <span class="sr-only text-warning">Loading...</span>
                                </div>
                            </div>
                            <span class="text-danger"> Aktifkan GPS Lokasi</span>
                        </div>
                        <div class="col-sm-12 text-center">&nbsp;</div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-12 text-center wow fadeInDown">
                            <div class="col-sm-12 text-center">&nbsp;</div>
                            <h5>Riwayat Absensi Terbaru</h5>
                            <template v-for="(datalist, urutlist) in riwayatabsen" :key="urutlist">
                                <div class="row px-5">
                                    <div class="col-sm-2 text-center"></div>
                                    <div class="col-sm-8 col-12">
                                        <div class="card" style="background-color: rgba(255, 255, 255, 0.1)">
                                            <div class="card-header bgbiru text-center">
                                                <h3 class="card-title text-white"><i class="far fa-clock "></i> {{
                                                    datalist.tanggal_masuk }}</h3>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-sm-6 col-6">
                                                        <div class="small-box bghadir">
                                                            <div class="inner">
                                                                <h3 class="hadir" style="font-size: 23px;">{{
                                                                    datalist.jam_masuk }}</h3>
                                                                <p class="text-warning">Masuk<br>{{
                                                                    datalist.tanggal_masuk }}</p>
                                                            </div>
                                                            <a href="javascript:void(0)" class="small-box-footer"
                                                                style="font-size: small;">
                                                                {{ datalist.lokasi_masuk }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6 col-6">
                                                        <div class="small-box bghadir">
                                                            <div class="inner">
                                                                <h3 class="hadir" style="font-size: 23px;">{{
                                                                    datalist.jam_pulang }}
                                                                </h3>
                                                                <p class="text-warning">Pulang<br>{{
                                                                    datalist.tanggal_pulang }}</p>
                                                            </div>
                                                            <a href="javascript:void(0)" class="small-box-footer"
                                                                style="font-size: small;">
                                                                {{ datalist.lokasi_pulang }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-center"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.content-header -->
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import Footer from "../componen/FooterAksi.vue";
import NavBar from "../componen/NavBarAksi.vue";
import Menu from "../componen/Menu.vue";
import swal from 'sweetalert2';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, apexchart: VueApexCharts,
    },
    data() {
        return {
            halamanloading: true,
            showFilter: true,
            iduser: JSON.parse(localStorage.getItem("isistemaksi")),
            leveluser: JSON.parse(localStorage.getItem("lsistemaksi")),
            namauser: JSON.parse(localStorage.getItem("namasistemaksi")),
            jabatanuser: JSON.parse(localStorage.getItem("jabatansistemaksi")),
            datapesan: '',
            sapaan: '',
            datamaster: [],
            carikata: '',
            datatahun: [],
            tahun: [],
            defaultSelectedtahun: {},
            selectedtahun: new Date().getFullYear(),
            jam: '',
            menit: '',
            detik: '',
            hasil: '',
            hariAngka: '',
            statusjam: '',
            timer: null,
            folder: process.env.VUE_APP_URL_API + 'androidAbsensi-Gambar?f=' + JSON.parse(localStorage.getItem("ikonsistemaksi")),
            latitude: '',
            longitude: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            jam_masuk: '',
            jam_pulang: '',
            tanggal_masuk: '',
            tanggal_pulang: '',
            tipe: '',
            id: '',
            ket: '',
            class: '',
            proses: '',
            durasi: '',
            jamdurasi: 0,
            menitdurasi: 0,
            detikdurasi: 0,
            riwayatabsen: [],
        }
    },
    methods: {
        LihatWaktu() {
            this.timer = setInterval(() => {
                var jam = new Date().getHours();
                if (jam < 12) {
                    this.sapaan = "Selamat Pagi";
                } else if (jam < 15) {
                    this.sapaan = "Selamat Siang";
                } else if (jam < 19) {
                    this.sapaan = "Selamat Sore";
                } else {
                    this.sapaan = "Selamat Malam";
                }

                var now = new Date();
                this.detikdurasi = this.detikdurasi;
                var jamnya = Math.floor(this.detikdurasi / 3600);
                var menitnya = Math.floor((this.detikdurasi % 3600) / 60);
                var detiknya = Math.floor(this.detikdurasi % 60);

                // Menambahkan angka 0 di depan jika < 10 (format 00:00:00)
                var jamStr = String(jamnya).padStart(2, '0');
                var menitStr = String(menitnya).padStart(2, '0');
                var detikStr = String(detiknya).padStart(2, '0');

                this.durasi = jamStr + ':' + menitStr + ':' + detikStr;
                if (this.proses == 'belumselesai') {
                    this.detikdurasi++;
                }


                this.jam = now.getHours();
                this.menit = now.getMinutes();
                this.detik = now.getSeconds();
                this.jam = (this.jam < 10) ? "0" + this.jam : this.jam;
                this.menit = (this.menit < 10) ? "0" + this.menit : this.menit;
                this.detik = (this.detik < 10) ? "0" + this.detik : this.detik;

                this.hariAngka = 'Jam: ' + this.jam + ':' + this.menit + ':' + this.detik; // 0 (Minggu) - 6 (Sabtu) [10]
                //this.durasi = this.jamdurasi + ':' + this.menitdurasi + ':' + this.detikdurasi; // 0 (Minggu) - 6 (Sabtu) [10]
                var tanggal = now.getDate(); // 1 - 31 [2]
                var bulan = now.getMonth(); // 0 - 11 [2]
                var tahun = now.getFullYear(); // 4 digit tahun [2]

                // Array nama hari dan bulan (opsional, untuk hasil dalam Bahasa Indonesia)
                var namaHari = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
                var namaBulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

                // Format: "Selasa, 3 Februari 2026"
                this.hasil = namaHari[now.getDay()] + ", " + tanggal + " " + namaBulan[bulan] + " " + tahun;

            }, 1000);
        },
        GPSBrowser() {
            if (navigator.geolocation) {
                const successCallback = (position) => {
                    this.latitude = position.coords.latitude;
                    this.longitude = position.coords.longitude;
                };
                const errorCallback = (error) => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Aktifkan GPS / Lokasi Gadget / Permission Location..',
                    });
                    return false;
                };

                navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
            }
            else {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Aktifkan GPS / Lokasi Gadget / Permission Location..',
                });
                return false;
            }
        },
        async cekabsen() {
            var fd = new FormData();
            fd.append("id_user", this.iduser);
            fd.append("project_id", this.project_id);

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                },
            });
            await mainAPI.post("androidAbsensi-GetDataTipeAbsen", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.id = Response.data.content.data[0].id;
                            this.jam_masuk = Response.data.content.data[0].jam_masuk;
                            this.jam_pulang = Response.data.content.data[0].jam_pulang;
                            this.ket = Response.data.content.data[0].ket;
                            this.class = Response.data.content.data[0].class;
                            this.tipe = Response.data.content.data[0].tipe;
                            this.statusjam = Response.data.content.data[0].jam;
                            this.proses = Response.data.content.data[0].proses;
                            this.tanggal_masuk = Response.data.content.data[0].tanggal_masuk;
                            this.tanggal_pulang = Response.data.content.data[0].tanggal_pulang;
                            this.detikdurasi = Response.data.content.data[0].diffSecond;
                            this.halamanloading = false;
                        }
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                this.halamanloading = false;
            }
            )
        },
        async riwayat_absen() {
            this.riwayatabsen = [];
            var fd = new FormData();
            fd.append("id_user", this.iduser);
            fd.append("level", this.leveluser);
            fd.append("project_id", this.project_id);

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                },
            });
            await mainAPI.post("RiwayatAbsen-GetData", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.riwayatabsen = Response.data.content.data;
                            this.halamanloading = false;
                        }
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                this.halamanloading = false;
            }
            )
        },
        async absenmasuk() {
            if (this.latitude == '' || this.latitude == null || this.latitude == undefined || this.latitude == '0') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Aktifkan GPS / Loksi'
                });
                return false;
            }
            this.halamanloading = true;
            var date = new Date();
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
            var day = date.getDate().toString().padStart(2, '0');
            var hours = date.getHours().toString().padStart(2, '0');
            var minutes = date.getMinutes().toString().padStart(2, '0');
            var seconds = date.getSeconds().toString().padStart(2, '0');
            var fd = new FormData();
            if (this.tipe == 'masuk') {
                fd.append("id_user", this.iduser);
                fd.append("tipe", this.tipe);
                fd.append("jam_masuk", year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds);
                fd.append("lattitude_masuk", this.latitude);
                fd.append("longitude_masuk", this.longitude);
                fd.append("project_id", this.project_id);
            }
            else {
                fd.append("id_user", this.iduser);
                fd.append("tipe", this.tipe);
                fd.append("jam_pulang", year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds);
                fd.append("lattitude_pulang", this.latitude);
                fd.append("longitude_pulang", this.longitude);
                fd.append("project_id", this.project_id);
            }

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                },
            });
            await mainAPI.post("androidAbsensiWeb-Absen", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                        this.halamanloading = false;
                    }
                    else {
                        this.halamanloading = false;
                        window.location.reload();
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                this.halamanloading = false;
            }
            )
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorageAksi();
                }
            });

            return false;
        },
    },
    mounted() {
        this.LihatWaktu();
        this.GPSBrowser();
        this.cekabsen();
        this.riwayat_absen();
        //this.halamanloading = false;
    }
}
</script>
<style></style>